
/*
 * RISK IS KEY — Product Variant Cart Sync
 * Keeps the Shopify product form's variant ID
 * synchronized with selected color and size.
 */

(function () {
  'use strict';

  function initVariantCartSync() {
    const form = document.querySelector(
      '.product-form[data-ajax-cart-form]'
    );

    if (!form) return;

    const variantData = form.querySelector(
      '[data-product-variants]'
    );

    const variantInput = form.querySelector(
      'input[name="id"][data-variant-id]'
    );

    if (!variantData || !variantInput) return;

    let variants;

    try {
      variants = JSON.parse(variantData.textContent);
    } catch (error) {
      console.error(
        'Risk is Key: Invalid variant data.',
        error
      );
      return;
    }

    const addButton = form.querySelector('[data-atc]');
    const stickyButton = document.querySelector(
      '[data-sticky-submit]'
    );

    function getSelectedVariant() {
      const selectedOptions = Array.from(
        form.querySelectorAll(
          '[data-option-value]:checked'
        )
      )
      .sort(
        (a, b) =>
          Number(a.dataset.position) -
          Number(b.dataset.position)
      )
      .map(input => input.value);

      return variants.find(variant =>
        variant.options.length === selectedOptions.length &&
        variant.options.every(
          (option, index) =>
            option === selectedOptions[index]
        )
      );
    }

    function syncVariant() {
      const variant = getSelectedVariant();

      if (!variant) {
        variantInput.value = '';

        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = 'UNAVAILABLE';
        }

        if (stickyButton) {
          stickyButton.disabled = true;
        }

        return null;
      }

      variantInput.value = String(variant.id);

      const available = Boolean(variant.available);

      if (addButton) {
        addButton.disabled = !available;

        addButton.textContent = available
          ? 'ADD TO BAG — ' + formatPrice(variant.price)
          : 'SOLD OUT';
      }

      if (stickyButton) {
        stickyButton.disabled = !available;
        stickyButton.textContent = available
          ? 'ADD TO BAG'
          : 'SOLD OUT';
      }

      return variant;
    }

    function formatPrice(cents) {
      const currency =
        window.Shopify?.currency?.active || 'USD';

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    // Run when a shopper selects color or size.
    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-option-value]')) {
        syncVariant();
      }
    });

    // Ensure the correct variant ID is present
    // before the existing AJAX handler reads FormData.
    form.addEventListener(
      'submit',
      function (event) {
        const variant = syncVariant();

        if (!variant || !variant.available) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    // Initialize the form with the selected variant.
    syncVariant();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initVariantCartSync
    );
  } else {
    initVariantCartSync();
  }
})();
